import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/core/services/translate/localstorage.service';
import { TranslateService } from 'src/app/core/services/translate/translate.service';
import { ButtonComponent } from '../../components/dashboard-component/button/button.component';
import { IconComponent } from '../../components/dashboard-component/icon/icon.component';

@Component({
	selector: 'app-page404',
	imports: [ButtonComponent],
	templateUrl: './page404.component.html',
	styleUrl: './page404.component.scss',
})
export class Page404Component {
	public router = inject(Router);
	public localService = inject(LocalStorageService);
	public ts = inject(TranslateService);

	continueHome() {
		this.router.navigateByUrl('dashboard/home');
	}
	continuePreferences() {
		this.router.navigateByUrl('dashboard/preferences');
	}
}
